<template>
  <a-modal
    :title="title"
    :visible="visible"
    :centered="true"
    :mask-closable="false"
    :width="672"
    :footer="false"
    wrap-class-name="tv-code-modal"
    @ok="handleOk"
    @cancel="handleCancel"
  >
    <div class="words">
      <p>{{ $t('message[1962]') }} </p>
      <p>1. {{ $t('message[1963]') }}</p>
      <p>
        2. {{ $t('message[1304]') }} <a
          href="https://help.westartrack.com/faq/d_5f6aee53200d5c007f250379.html?5xyFrom=site-NT"
          target="_blank"
          class="fs-blue"
        >apk</a> {{ $t('message[1964]') }}
      </p>
    </div>
    <div class="wrap">
      <div class="item item1 clearfix">
        <label class="fl">{{ $t('message[1808]') }}：</label>
        <span class="fl">{{ previewCode }}</span>
        <i
          class="iconfont iconfuzhi fl"
          @click="handleCopyCode"
        />
        <p
          v-if="copySuccess2"
          class="success-tip fl"
        >
          <i class="iconfont iconicon-test70 m-r-5" />{{ $t('message[321]') }}
        </p>
      </div>
      <div class="item clearfix">
        <span class="input fl">{{ previewUrl }}<i>{{ previewCode }}</i></span>
      </div>
      <div class="item clearfix">
        <a-button
          type="primary"
          class="fl m-r-16"
          @click="handleCopyUrl"
        >
          <!-- 复制链接 -->
          {{ $t('message[1968]') }}
        </a-button>
        <p
          v-if="copySuccess1"
          class="success-tip fl"
        >
          <i class="iconfont iconicon-test70 m-r-5" />{{ $t('message[321]') }}
        </p>
      </div>
    </div>
  </a-modal>
</template>

<script>
export default {
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    previewCode: {
      type: String,
      default: ''
    },
    title: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      copySuccess1: false,
      copySuccess2: false
    }
  },
  computed: {
    previewUrl () {
      let { port, protocol, hostname } = location
      const isDingding = hostname.indexOf('dtwork') > -1
      let env
      if (port === '93') {
        env = '.dev'
        port = ':' + port
      } else if (port === '89') {
        env = '.dev'
        port = ':' + port
      } else {
        env = ''
      }
      let href = protocol + '//tv' + env + '.westartrack.com' + port + '/?code='
      if (isDingding) {
        href = protocol + '//tv' + env + '.westartrack.com' + port + '/?dingtalk=1&code='
      }
      return href
    }
  },
  methods: {
    hide () {
      this.$emit('update:visible', false)
      this.copySuccess1 = false
      this.copySuccess2 = false
    },
    copyValue (val) {
      // 如果这里换为 input 则不支持换行
      var temp = document.createElement('textarea')
      temp.value = val
      document.body.appendChild(temp)
      temp.select() // 选择对象
      document.execCommand('Copy') // 执行浏览器复制命令
      temp.style.display = 'none'
    },
    handleCopyUrl () {
      this.copyValue(this.previewUrl + this.previewCode)
      this.copySuccess1 = true
    },
    handleCopyCode () {
      this.copyValue(this.previewCode)
      this.copySuccess2 = true
    },
    handleOk () {
      this.hide()
    },
    handleCancel () {
      this.hide()
    }
  }
}
</script>
<style scoped lang="scss">
.words {
  padding: 8px 24px;
  line-height: 24px;
  background: #E8F4FF;
}
.help-btn {
  display: inline-block;
  margin: 8px 0;
  height: 24px;
}
.wrap {
  padding: 24px 47px 40px;
  .item {
    margin-bottom: 16px;
  }
  label {
    font-size: 14px;
  }
  .input {
    width: 420px;
    height: 32px;
    line-height: 32px;
    padding: 0 12px;
    white-space: nowrap;
    background: #F5F5F5;
    border-radius: 4px;
    border: 1px solid #D6D6D6;
  }
  i {
    font-style: normal;
  }
  .iconfuzhi {
    margin: -3px 8px 0 8px;
    font-size: 20px;
    cursor: pointer;
  }
  .success-tip {
    line-height: 32px;
    .iconfont {
      color: #42C27E;
      font-size: 14px;
    }
  }
  .item1 .success-tip {
    line-height: normal;
  }
}
</style>

<style lang="scss">
.tv-code-modal {
  .ant-modal-header {
    height: 56px;
    padding: 16px 21px;
  }
  .ant-modal-body {
    padding: 0;
  }
}
</style>
